const getHelpButton = document.querySelector(".webinar-help__button");
const bodyContainer = document.querySelector(".body-container");
const modal = document.querySelector(".form-modal");

if (getHelpButton) {
  getHelpButton.addEventListener("click", () => {
    modal.classList.add("site-modal--opened");
    modal.querySelector("#type").value = "webinar";
    modal.querySelector("#hidden_item_name").value = document.querySelector(
      "h1"
    )?.innerText;
    modal.querySelector("#page_link").value = window.location.href;
    modal.querySelector("#form_type").value = "Узнать больше";
    bodyContainer?.classList.add("body-container--no-scroll");
  });
}
